import { render, staticRenderFns } from "./StatRow.vue?vue&type=template&id=7da95a02&scoped=true"
import script from "./StatRow.vue?vue&type=script&lang=js"
export * from "./StatRow.vue?vue&type=script&lang=js"
import style0 from "./StatRow.vue?vue&type=style&index=0&id=7da95a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da95a02",
  null
  
)

export default component.exports